module.exports = [
	{
		"index": 0,
		"name": "Grocery",
		"active": true
	},
	{
		"index": 1,
		"name": "Toys",
		"active": false
	},
	{
		"index": 2,
		"name": "Home Appliances",
		"active": false
	},
	{
		"index": 3,
		"name": "Furniture",
		"active": false
	},
	{
		"index": 4,
		"name": "Clothing",
		"active": true
	},
	{
		"index": 5,
		"name": "Home Hardware",
		"active": false
	},
	{
		"index": 6,
		"name": "Sports",
		"active": false
	},
	{
		"index": 7,
		"name": "Electronics",
		"active": false
	},
	{
		"index": 8,
		"name": "Instruments",
		"active": false
	},
	{
		"index": 9,
		"name": "Gas Station",
		"active": false
	},
	{
		"index": 10,
		"name": "Car Dealer",
		"active": false
	},
	{
		"index": 11,
		"name": "Book Shop",
		"active": false
	},
	{
		"index": 12,
		"name": "Jewellery",
		"active": false
	},
	{
		"index": 13,
		"name": "Coffee Shop",
		"active": false
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/stores.json
// module id = 343
// module chunks = 0